import { validateAgent } from '@/apis/agent';
import { AgentResponse, AgentState } from '@/types/Agent';
import { ApiResponseWrapper } from '@/types/Common/Wrapper';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: AgentState = {
  loading: false,
  isValid: true,
  environmentEntity: '',
};

export const agentSlice = createSlice({
  name: 'agent',
  initialState,
  reducers: {
    setAgentId: (state, action: PayloadAction<string | undefined>) => {
      state.agentId = action.payload;
    },
    setEnvironmentEntity: (state, action: PayloadAction<string>) => {
      state.environmentEntity = action.payload;
    },
    resetAgent: (state) => {
      state.agentCode = undefined;
      state.agentId = undefined;
      state.entity = undefined;
      state.loading = false;
      state.isValid = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateAgent.pending, (state) => {
        state.loading = true;
        state.agentCode = undefined;
      })
      .addCase(validateAgent.fulfilled, (state, action) => {
        state.loading = false;
        const response: ApiResponseWrapper<AgentResponse> = action.payload;

        if (!response.succeeded) {
          state.isValid = false;
          state.agentCode = undefined;
          state.agentId = undefined;
          state.entity = undefined;
        } else {
          if (state.environmentEntity === response.data.entity) {
            state.isValid = true;
            state.agentCode = response.data.agentCode;
            state.entity = response.data.entity;
            
          } else {
            state.isValid = false;
            state.agentId = undefined;
            state.agentCode = undefined;
            state.entity = undefined;
          }
        }
      })
      .addCase(validateAgent.rejected, (state) => {
        state.loading = false;
        state.isValid = false;
        state.entity = undefined;
        state.agentCode = undefined;
        state.agentId = undefined;
      });
  },
});

export const { setAgentId, resetAgent, setEnvironmentEntity } =
  agentSlice.actions;
export default agentSlice.reducer;
